import instanceAxios from "../config/config";
import { AxiosResponse } from "axios";

interface DeckListParams {
    page?: number;
    limit?: number;
    search?: string;
}

interface user {
    _id: string;
    full_name: string;
    email_address: string;
    phone_number: string;
    role: string;
    status: string;
    createdAt: string;
}

interface category {
    _id: string;
    title: string;
}

interface Deck {
    _id: string;
    title: string;
    description: string;
    tags?: string[];
    type: string;
    likes: number;
    completion_count: number;
    average_time_spent: number;
    view_count: number;
    active_usage_count: number;
    retention_rate: number;
    search_appearances: number;
    click_count: number;
    conversion_rate: number;
    createdAt: string;
    user: user[];
    flashcard_count: number;
    category: category[];
    image: string;
}

interface DeckListResponse {
    deck: Deck[];
    count: number;
}

interface dataDeck {
    status: number;
}

interface CreateDeckParams {
    title: string;
    description: string;
    user_id: string;
    data: dataDeck;
}

const BASE_URL = `/deck`;

const DeckService = {
    getDecks: (params?: DeckListParams): Promise<AxiosResponse<DeckListResponse>> => {
        const queryParams = {
            page: Number(params?.page),
            limit: Number(params?.limit),
            search: params?.search
        };
        return instanceAxios.post(`${BASE_URL}/getDecksAdmin`, queryParams);
    },

    createDeck: (deckData: Partial<Deck>): Promise<AxiosResponse> => {
        return instanceAxios.post(`${BASE_URL}/createDeck`, deckData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    deleteDeck: (id: string): Promise<AxiosResponse> => {
        return instanceAxios.delete(`${BASE_URL}/${id}`);
    },

    getDeckWithObjecId: (deck_id: string): Promise<AxiosResponse> => {
        return instanceAxios.get(`${BASE_URL}/getOne/${deck_id}`);
    },

    updateDeckWithObjecId: (_id: string, deckData: Partial<Deck>): Promise<AxiosResponse> => {
        return instanceAxios.put(`${BASE_URL}/updateOne/${_id}`, deckData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },

    deckStatistics: (): Promise<AxiosResponse> => {
        return instanceAxios.post(`${BASE_URL}/deckStatistics`);
    },

    getDecksInCategory: (category_id: string | undefined, params?: DeckListParams): Promise<AxiosResponse<DeckListResponse>> => {
        const queryParams = {
            page: Number(params?.page),
            limit: Number(params?.limit),
            search: params?.search
        };
        return instanceAxios.post(`${BASE_URL}/getDecksInCategory/${category_id}`, queryParams);
    },

    getTags: (params?: DeckListParams): Promise<any> => {
        return instanceAxios.get(`${BASE_URL}/tags`, {
            params: {
                page: Number(params?.page) || 1,
                limit: Number(params?.limit) || 10,
                search: params?.search || ""
            }
        });
    },
};

export default DeckService;